import React from "react";
// style components
import { Modal, Form, Input, Button} from "antd";

// hooks
import { useAgregarExperienciaJurado } from "../../../hooks/useAgregarExperienciaJurado";
import DocumentInput from "../../../utils/DocumentInput";
import DocumentosService from "../../../api/Documentos/api-documentos";
import { initialValuesExperienciaProfesionalModel } from "../../../models/JuradosModel/agregarExpericienciaProfesional.model";
import DateInput from "../../../utils/DateInput";

// models
interface IProps {
  experiencia: any;
  setExperiencia: any;
  experiencias: any;
  setExperiencias: any;
  modal: boolean;
  setModal: any;
  guardarCambios: any;
  limpiarcampos: any;
  cancelar: any;
}

export const ModalEditarExperienciasProfesionales: React.FC<IProps> = (
  props: IProps
) => {
  const { fileInputRef } = useAgregarExperienciaJurado();

  const fields = [
    { name: "nombre", value: props.experiencia.nombre },
    { name: "fecha_inicio", value: props.experiencia.fecha_inicio },
    { name: "fecha_terminacion", value: props.experiencia.fecha_terminacion },
    { name: "cargo", value: props.experiencia.cargo },
    { name: "funciones", value: props.experiencia.funciones },
    { name: "documento", value: props.experiencia.documento },
  ];

  const onCancel = () => {
    props.setExperiencia(initialValuesExperienciaProfesionalModel);
    props.setModal(false);
  };

  const guardarArchivo = async (e: any) => {
    if (e.target.files.length > 0) {
      const formData = new FormData();
      formData.append("archivo", e.target.files[0]);
      const data = await DocumentosService.guardarArchivo(formData);
      return props.setExperiencia({ ...props.experiencia, documento: data.data });
    }
  };

  return (
    <Modal
      title={
        <span className="font-family-Montserrat-Bold">
          Editar experiencia -{" "}
          <span className="font-color-DB2828 font-size-10px font-family-Montserrat-Regular">
            Todos los campos son obligatorios
          </span>
        </span>
      }
      style={{ top: 60 }}
      width={window.innerWidth * 0.9}
      visible={props.modal}
      onCancel={onCancel}
      footer={[
        <Button key="B_CancelarModalEditarExpProf" className="button-gray-ghost" onClick={onCancel}>
          Cancelar
        </Button>,
        <Button key="B_LimpiarModalEditarExpProf"
          style={{ marginBottom: "20px" }}
          className="button-azul-ghost font-size-12px"
          onClick={() => props.limpiarcampos()}
        >
          Limpiar campos
        </Button>,
        <Button
          className="button-azul-radius"
          form="modalEditarExperienciaPorfesional"
          key="submit"
          htmlType="submit"
        >
          Guardar cambios
        </Button>,
      ]}
      maskStyle={{
        backgroundColor: "rgba(31,174,239,0.8)",
      }}
    >
      <Form
        size="large"
        name="modalEditarExperienciaPorfesional"
        onFinish={props.guardarCambios}
        fields={fields}
        onFieldsChange={(_, fields: any) => {
          let infoupdate: any = { ...props.experiencia };
          for (const i in fields) {
            infoupdate[fields[i].name] = fields[i].value;
          }
          props.setExperiencia(infoupdate);
        }}
      >
        <div className="row">
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Nombre entidad / Proyecto
            </span>
            <Form.Item
              className="no-margin"
              name="nombre"
              rules={[{ required: true, message: "" }]}
            >
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Fecha de inicio
            </span>
            <Form.Item
              className="no-margin"
              name="fecha_inicio"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DateInput
                save={(fecha) => {
                  props.setExperiencia({
                    ...props.experiencia,
                    fecha_inicio: fecha,
                  });
                }}
                dia={props.experiencia?.fecha_inicio?.split("-")[2] || ""}
                mes={props.experiencia?.fecha_inicio?.split("-")[1] || ""}
                anio={props.experiencia?.fecha_inicio?.split("-")[0] || ""}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-3 col-xxl-3 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Fecha de terminación
            </span>
            <Form.Item
              className="no-margin"
              name="fecha_terminacion"
              rules={[{ required: true, message: "Campo obligatorio" }]}
            >
              <DateInput
                save={(fecha) => {
                  props.setExperiencia({
                    ...props.experiencia,
                    fecha_terminacion: fecha,
                  });
                }}
                dia={props.experiencia?.fecha_terminacion?.split("-")[2] || ""}
                mes={props.experiencia?.fecha_terminacion?.split("-")[1] || ""}
                anio={props.experiencia?.fecha_terminacion?.split("-")[0] || ""}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-6 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Cargo / Rol desempeñado
            </span>
            <Form.Item
              className="no-margin"
              name="cargo"
              rules={[{ required: true, message: "" }]}
            >
              <Input />
            </Form.Item>
          </div>
          <div className="col-12 col-md-12 col-lg-6 col-xxl-6 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Anexar documento
            </span>
            <Form.Item
              className="no-margin"
              name="documento"
              rules={[{ required: true, message: "Documento obligatorio" }]}
            >
              <DocumentInput
                doc={props.experiencia.documento}
                fileInputRef={fileInputRef}
                ancho_btn={30}
                on_change={(e) => {
                  guardarArchivo(e);
                  e.target.value = "";
                }}
                onDelete={() => {
                  props.setExperiencia({
                    ...props.experiencia,
                    documento: "",
                  });
                }}
              />
            </Form.Item>
          </div>
          <div className="col-12 col-md-12 col-lg-12 col-xxl-12 mt-4">
            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
              Funciones principales
            </span>
            <Form.Item
              className="no-margin"
              name="funciones"
              rules={[{ required: true, message: "" }]}
            >
              <Input.TextArea showCount maxLength={1000} />
            </Form.Item>
          </div>
        </div>
      </Form>
    </Modal>
  );
};
